import {createReducer} from '../utility'




export const displine = createReducer({},{
    "FETCH_DISCIPLINE_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                displines: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})